import m from "mithril";

const KinerjaRealisasi = {
    view: function() {
        return m("div", { class: "container mx-auto p-4" }, [
            m("div", { class: "flex flex-col md:flex-row gap-6 justify-center mt-10" }, [
                // Pinjaman Card
                m("div", {
                    class: "w-full md:w-80 bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden transform transition hover:scale-105 cursor-pointer border border-gray-100 dark:border-gray-700",
                    onclick: () => m.route.set("/loans-performance")
                }, [
                    m("div", { class: "h-32 bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center" }, [
                        m("i", { class: "ri-hand-coin-line text-5xl text-white" })
                    ]),
                    m("div", { class: "p-6 text-center" }, [
                        m("h3", { class: "text-xl font-bold text-gray-800 dark:text-white mb-2" }, "Pinjaman"),
                        m("p", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "Lihat realisasi kinerja penyaluran pinjaman hari ini.")
                    ])
                ]),

                // Simpanan Card
                m("div", {
                    class: "w-full md:w-80 bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden transform transition hover:scale-105 cursor-pointer border border-gray-100 dark:border-gray-700",
                    onclick: () => m.route.set("/savings-performance")
                }, [
                    m("div", { class: "h-32 bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center" }, [
                        m("i", { class: "ri-safe-2-line text-5xl text-white" })
                    ]),
                    m("div", { class: "p-6 text-center" }, [
                        m("h3", { class: "text-xl font-bold text-gray-800 dark:text-white mb-2" }, "Simpanan"),
                        m("p", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "Lihat realisasi kinerja setoran dan penarikan simpanan.")
                    ])
                ])
            ])
        ]);
    }
};

export default KinerjaRealisasi;
